import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useCart } from "../context/cart";
import toast from "react-hot-toast";
import { getImageUrl } from "../utils/imageHelper";
import api from "../utils/axiosInstance";

const MostViewedProducts = ({ id, limit = 6 }) => {
  const navigate = useNavigate();
  const [cart, setCart] = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const PALETTE = {
    PRIMARY_BLUE: "#6A9DD5",
    DARK_NAVY: "#1C2E4A",
    ACCENT_BROWN: "#7C4F2B",
  };

  const getMostViewedProducts = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/v1/product/product-list/1");
      const sortedByViews = (data?.products || [])
        .sort((a, b) => (b.views || 0) - (a.views || 0))
        .slice(0, limit);
      setProducts(sortedByViews);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    getMostViewedProducts();
  }, []);

  

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="text-gray-500 text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <section id={id} className="w-full py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* HEADER */}
        <div className="text-center mb-12">
          <h2
            className="text-3xl font-light tracking-widest uppercase"
            style={{ color: PALETTE.DARK_NAVY }}
          >
            Most Viewed
          </h2>
          <div
            className="w-24 h-px mx-auto mt-4"
            style={{ backgroundColor: PALETTE.ACCENT_BROWN }}
          />
        </div>

        {/* PRODUCTS GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 justify-items-center">
          {products.map((product) => (
            <div
              key={product._id}
              className="group w-full max-w-sm bg-white overflow-hidden transition-shadow duration-300 flex flex-col"
            >
              {/* IMAGE CONTAINER */}
              <div
                className="relative w-full aspect-square sm:h-96 overflow-hidden cursor-pointer"
                onClick={() => navigate(`/product/${product.slug}`)}
              >
                <img
                  src={getImageUrl(product.photos[0])}
                  onError={(e) => {
                    e.target.src = "/images/fallback-RB.png";
                  }}
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-105"
                />
              </div>

              {/* DETAILS CONTAINER */}
              <div className="flex flex-col flex-grow pt-4">
                <div className="px-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2 tracking-wide">
                    {product.name.length > 30
                      ? `${product.name.slice(0, 30)}...`
                      : product.name}
                  </h3>
                  <p className="text-sm text-gray-500 mb-3 line-clamp-2">
                    {product.description.length > 30
                      ? `${product.description.slice(0, 30)}...`
                      : product.description}
                  </p>
                  <div className="mb-4">
                    <div className="flex items-center gap-3 flex-wrap">
                      {/* Selling Price */}
                      <span
                        className="text-2xl font-bold"
                        style={{ color: PALETTE.DARK_NAVY }}
                      >
                        ₹{product.price?.toLocaleString("en-IN")}
                      </span>

                      {/* MRP */}
                      {product.actualPrice &&
                        Number(product.actualPrice) > Number(product.price) && (
                          <span className="text-base text-gray-400 line-through">
                            ₹
                            {Number(product.actualPrice).toLocaleString(
                              "en-IN",
                            )}
                          </span>
                        )}
                    </div>

                    {/* Discount */}
                    {product.actualPrice &&
                      Number(product.actualPrice) > Number(product.price) && (
                        <div className="mt-2 flex items-center gap-2 flex-wrap">
                          <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
                            {Math.round(
                              ((product.actualPrice - product.price) /
                                product.actualPrice) *
                                100,
                            )}
                            % OFF
                          </span>

                          <span className="text-xs text-gray-500">
                            Save ₹
                            {(
                              product.actualPrice - product.price
                            ).toLocaleString("en-IN")}
                          </span>
                        </div>
                      )}
                  </div>
                </div>

                {/* BUTTON - Full Width matching Image */}
                <div className="mt-auto w-full">
                  <button
                    className="w-full py-3 text-sm tracking-wider uppercase font-bold text-black bg-transparent border border-black transition-all duration-300 hover:bg-black hover:text-white"
                    onClick={() => navigate(`/product/${product.slug}`)}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* VIEW ALL PRODUCTS BUTTON */}
        <div className="mt-16 text-center">
          <button
            onClick={() => navigate("/products")}
            className="px-10 py-3.5 text-sm font-semibold tracking-widest transition-all duration-300 border-2 hover:text-white"
            style={{
              borderColor: "black",
              color: "black",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "black";
              e.currentTarget.style.color = "#FFFFFF";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "black";
            }}
          >
            View All Products
          </button>
        </div>
      </div>
    </section>
  );
};

export default MostViewedProducts;
